// Single source of truth for semantic UI colors.
// Use C.xxx in inline JSX styles; use var(--abi-xxx) in CSS/className contexts.
export const C = {
  primary:  '#2563eb',
  accent:   '#7c3aed',
  provider: '#059669',
  danger:   '#ef4444',
  success:  '#10b981',
  warning:  '#f59e0b',
};

// Order status badge styles (id 1 = pending, 2 = customer-approved, 3 = provider-approved)
export const STATUS_STYLE = {
  1: { background: '#fef9c3', color: '#854d0e', border: '1px solid #fde047' },
  2: { background: '#dbeafe', color: '#1e40af', border: '1px solid #93c5fd' },
  3: { background: '#dcfce7', color: '#166534', border: '1px solid #86efac' },
};

// Widget health-status color tokens (ok / warning / danger)
export const STATUS_COLORS = {
  ok:      { bg: '#ecfdf5', border: `${C.success}33`, dot: C.success, text: '#064e3b' },
  warning: { bg: '#fffbeb', border: `${C.warning}33`, dot: C.warning, text: '#92400e' },
  danger:  { bg: '#fff1f2', border: `${C.danger}33`,  dot: C.danger,  text: '#7f1d1d' },
};

// Fund-consumption bar color based on % used
export function barColor(pct) {
  if (pct >= 80) return C.danger;
  if (pct >= 50) return C.warning;
  return C.success;
}
